import * as React from 'react';
import { Edit, EditProps, minValue, NumberInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { ELanguage } from "../enums";

export const OrganizationCoachNotificationEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="title" label="TITLE"/>
				<TextInput step={1} source="body" label="BODY" validate={[required()]}/>
				<NumberInput step={1} source="numberOfDaysSinceClientStart" label="NUMBER_OF_DAYS_SINCE_CLIENT_START" validate={[minValue(0), required()]}/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Edit>
	);
};
